import { createContext, Dispatch, useCallback, useContext, useMemo } from 'react'

import { Actions, ResultsState } from './state'

interface Context {
  hideTeamPositions: ResultsState['hideTeamPositions']
  noAnimations: ResultsState['noAnimations']
  allowCustomTemplateEdits: ResultsState['allowCustomTemplateEdits']
  onCustomTemplateEdit: ResultsState['onCustomTemplateEdit']
  updateHideTeamPositions: (payload: boolean) => void
  updateNoAnimations: (payload: boolean) => void
  updateAllowCustomTemplateEdits: (payload: boolean) => void
  updateOnCustomTemplateEdit: (payload: ResultsState['onCustomTemplateEdit']) => void
}

const NotImplemented = () => console.error('Context Method not implemented')

export const ResultsContext = createContext<Context>({
  hideTeamPositions: false,
  noAnimations: false,
  allowCustomTemplateEdits: false,
  onCustomTemplateEdit: NotImplemented,
  updateHideTeamPositions: NotImplemented,
  updateNoAnimations: NotImplemented,
  updateAllowCustomTemplateEdits: NotImplemented,
  updateOnCustomTemplateEdit: NotImplemented
})

export const useResultsContextValue = (state: ResultsState, dispatch: Dispatch<Actions>): Context => {
  const updateHideTeamPositions = useCallback((payload: boolean) => {
    dispatch({
      type: 'UpdateHideTeamPositions',
      payload
    })
  }, [dispatch])

  const updateNoAnimations = useCallback((payload: boolean) => {
    dispatch({
      type: 'UpdateNoAnimations',
      payload
    })
  }, [dispatch])

  const updateAllowCustomTemplateEdits = useCallback((payload: boolean) => {
    dispatch({
      type: 'UpdateAllowCustomTemplateEdits',
      payload
    })
  }, [dispatch])

  const updateOnCustomTemplateEdit = useCallback((payload: ResultsState['onCustomTemplateEdit']) => {
    dispatch({
      type: 'UpdateOnCustomTemplateEdit',
      payload
    })
  }, [dispatch])

  const context = useMemo(() => ({
    hideTeamPositions: state.hideTeamPositions,
    noAnimations: state.noAnimations,
    allowCustomTemplateEdits: state.allowCustomTemplateEdits,
    onCustomTemplateEdit: state.onCustomTemplateEdit,
    updateHideTeamPositions,
    updateNoAnimations,
    updateAllowCustomTemplateEdits,
    updateOnCustomTemplateEdit
  }), [state.hideTeamPositions, updateHideTeamPositions, state.noAnimations, updateNoAnimations, state.allowCustomTemplateEdits, updateAllowCustomTemplateEdits, state.onCustomTemplateEdit, updateOnCustomTemplateEdit])

  return context
}

export const useResultsContext = () => {
  return useContext(ResultsContext)
}